class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);


document.addEventListener('DOMContentLoaded', function() {
  const button1 = document.getElementById('button-1');
  const button2 = document.getElementById('button-2');
  const button3 = document.getElementById('button-3');
  
  
  function getInitialGridStateDesktop() {
    const savedGridColumns = localStorage.getItem('gridColumnsDesktop');
    return savedGridColumns || '4';
  }

  function getInitialCardContentVisibility() {
    const savedCardContentVisibility = localStorage.getItem('cardContentVisibility');
    return savedCardContentVisibility === 'hidden';
  }

  

  button1.addEventListener('click', function() {
    updateGridColumnsDesktop('4');
    setActiveButton(button1);
    showCardContent();
    console.log("4")
  });

  button2.addEventListener('click', function() {
    updateGridColumnsDesktop('8');
    setActiveButton(button2);
    showCardContent();
    console.log("8")
  });

  button3.addEventListener('click', function() {
    updateGridColumnsDesktop('12');
    setActiveButton(button3);
    hideCardContent();
    console.log("12")
  });

  const initialGridStateDesktop = getInitialGridStateDesktop();
  const productGrid = document.getElementById('search-grid');
  productGrid.className = productGrid.className.replace(/grid--\d+-col-desktop/g, `grid--${initialGridStateDesktop }-col-desktop`);
  productGrid?.classList.remove("grid--1-col-desktop")
  if (initialGridStateDesktop  === '4') {
    setActiveButton(button1);
  } else if (initialGridStateDesktop  === '8') {
    setActiveButton(button2);
  } else if (initialGridStateDesktop  === '12') {
    setActiveButton(button3);
  } 
  
  function updateGridColumnsDesktop(columnsDesktop) {
    const productGrid = document.getElementById('search-grid');
    productGrid.className = productGrid.className.replace(/grid--\d+-col-desktop/g, `grid--${columnsDesktop}-col-desktop`);
    localStorage.setItem('gridColumnsDesktop', columnsDesktop);
  }

  function setActiveButton(activeButton) {
    [button1, button2, button3].forEach(button => button.classList.remove('zoom-buttom--selected'));
    activeButton.classList.add('zoom-buttom--selected');
  }

  function hideCardContent() {
    const cardContents = document.querySelectorAll('.card__content');
    cardContents.forEach(content => {
      content.style.display = 'none';
    });
    localStorage.setItem('cardContentVisibility', 'hidden');
  }

  function showCardContent() {
    const cardContents = document.querySelectorAll('.card__content');
    cardContents.forEach(content => {
      content.style.display = '';
    });
    localStorage.setItem('cardContentVisibility', 'visible');
  }

  if (getInitialCardContentVisibility()) {
    hideCardContent();
  }
  productGrid.classList.add('ready');
});


document.addEventListener('DOMContentLoaded', function() {
  const button4 = document.getElementById('button-4');
  const button5 = document.getElementById('button-5');
  const button6 = document.getElementById('button-6');
  const productGrid = document.getElementById('search-grid');

  function getInitialGridStateMobile() {
  const savedGridColumnsMobile = localStorage.getItem('gridColumnsMobile');
  return savedGridColumnsMobile || '2';
  }

  function getInitialCardContentVisibility() {
    const savedCardContentVisibility = localStorage.getItem('cardContentVisibility');
    return savedCardContentVisibility === 'hidden';
  }

  // Set the initial state
  const initialGridStateMobile = getInitialGridStateMobile();
  productGrid.className = productGrid.className.replace(/grid--\d+-col-tablet-down/g, `grid--${initialGridStateMobile}-col-tablet-down`);
  if (initialGridStateMobile === '2') {
    setActiveButton(button4);
  } else if (initialGridStateMobile === '3') {
    setActiveButton(button5);
  } else if (initialGridStateMobile === '4') {
    setActiveButton(button6);
  }

  button4.addEventListener('click', function() {
  updateGridColumnsMobile('2');
  setActiveButton(button4);
  showCardContent()
  });

  button5.addEventListener('click', function() {
  updateGridColumnsMobile('3');
  setActiveButton(button5);
  showCardContent()
  });

  button6.addEventListener('click', function() {
  updateGridColumnsMobile('4');
  setActiveButton(button6);
  hideCardContent()
  });

  function updateGridColumnsMobile(columnsMobile) {
    const productGrid = document.getElementById('search-grid');
  productGrid.className = productGrid.className.replace(/grid--\d+-col-tablet-down/g, `grid--${columnsMobile}-col-tablet-down`);
  localStorage.setItem('gridColumnsMobile', columnsMobile);
    scrollToInitialState();
  }

  
  function setActiveButton(activeButton) {
  [button4, button5, button6].forEach(button => button.classList.remove('zoom-buttom--selected1'));
  activeButton.classList.add('zoom-buttom--selected1');
  }

  function hideCardContent() {
    const cardContents = document.querySelectorAll('.card__content');
    cardContents.forEach(content => {
      content.style.display = 'none';
    });
    localStorage.setItem('cardContentVisibility', 'hidden');
  }

  function showCardContent() {
    const cardContents = document.querySelectorAll('.card__content');
    cardContents.forEach(content => {
      content.style.display = '';
      content.removeAttribute('href');
    });
    localStorage.setItem('cardContentVisibility', 'visible');
  }

  if (getInitialCardContentVisibility()) {
    hideCardContent();
  }
  productGrid.classList.add('ready');
});


document.addEventListener('DOMContentLoaded', function () {
  let lastScrollTop = 0;
  const scrollThreshold = 7;
  let isCompact = false;

  const facets = document.querySelector('.template-search .facets-wrapper');
  const header = document.querySelector('.header-wrapper');
  const logo = document.querySelector('.header__heading-link');
  const header_sub = document.querySelector('.header');
  const searchHead = document.querySelector('.template-search .template-search__header');
  const searchInput = document.querySelector('.template-search .search__input.field__input');
  
  if (!header || !logo || !header_sub || !searchHead || !searchInput) return;

  function applyisTopStyles() {
    if (facets) {
      facets.classList.remove('facets--compact');
      facets.style.height = '46px';
      facets.style.transition = 'top .65s ease-in-out';
      facets.style.overflow = '';
    }
    logo.style.maxHeight = '105px';
    logo.style.overflow = 'hidden';
    header.style.height = '105px';
    header.style.minHeight = '105px';
    header_sub.style.height = '105px';
    header_sub.style.background = '';
    searchHead.style.top = '';
    searchHead.style.transition = 'top .65s ease-in-out';
    searchHead.style.background = '';
    searchInput.style.border = '';
  }

  function applyScrollUpStyles() {  /* 👆 */
    if (facets) {
      facets.classList.add('facets--compact');
      facets.style.height = '';
      facets.style.transition = '';
      facets.style.overflow = '';
    }
    header.style.height = '48px';
    header.style.minHeight = '48px';
    header_sub.style.background = 'rgba(255, 255, 255, 0.8)';
    header_sub.style.height = '48px';
    logo.style.maxHeight = '0';
    logo.style.overflow = 'hidden';
    searchHead.style.top = '48px';
    searchHead.style.background = 'rgba(255, 255, 255, 0.8)';
    searchInput.style.border = 'none';
  }

  function applyScrollDownStyles() { /* 👇 */
    if (facets) {
      facets.classList.remove('facets--compact');
      facets.style.height = '0px';
      facets.style.transition = '';
      facets.style.overflow = 'hidden';
    }
    header.style.height = '48px';
    header.style.minHeight = '48px';
    header_sub.style.background = 'linear-gradient(rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0) 100%)';
    header_sub.style.height = '48px';
    logo.style.maxHeight = '0';
    logo.style.overflow = 'hidden';
    searchHead.style.top = '48px';
    searchHead.style.background = '';
    searchInput.style.border = '';
  }
  
  function applyisBottomStyles() {
    if (facets) {
      facets.style.height = '0px';
      facets.style.overflow = 'hidden';
      facets.style.transition = '';
    }
    header.style.height = '48px';
    header.style.minHeight = '48px';
    header_sub.style.background = 'linear-gradient(rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0) 100%)';
    header_sub.style.height = '48px';
    logo.style.maxHeight = '0';
    logo.style.overflow = 'hidden';
    searchHead.style.top = '48px';
    searchHead.style.background = '';
    searchInput.style.border = '';
  }

  function handleScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isTop = currentScrollTop <= 0;
    const isBottom = window.innerHeight + currentScrollTop >= document.documentElement.scrollHeight;

    if (window.innerWidth > 749) return;

    if (isTop) {
      applyisTopStyles();
      isCompact = false;
    } else if (isBottom) {
      applyisBottomStyles();
      isCompact = true;
    } else {
      const scrollDiff = currentScrollTop - lastScrollTop;

      if (Math.abs(scrollDiff) > scrollThreshold) {
        if (scrollDiff > 0 && !isCompact) {
          applyScrollDownStyles();
          isCompact = true;
        } else if (scrollDiff < 0 && isCompact) {
          applyScrollUpStyles();
          isCompact = false;
        }
      }
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
});

